"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * The ScriptRunResult model module.
 * @module model/ScriptRunResult
 * @version 1.0.0
 */
var ScriptRunResult = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ScriptRunResult</code>.
   * @alias module:model/ScriptRunResult
   */
  function ScriptRunResult() {
    _classCallCheck(this, ScriptRunResult);
    ScriptRunResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  _createClass(ScriptRunResult, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>ScriptRunResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScriptRunResult} obj Optional instance to populate.
     * @return {module:model/ScriptRunResult} The populated <code>ScriptRunResult</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ScriptRunResult();
        if (data.hasOwnProperty('logs')) {
          obj['logs'] = _ApiClient.default.convertToType(data['logs'], 'String');
        }
        if (data.hasOwnProperty('files')) {
          obj['files'] = _ApiClient.default.convertToType(data['files'], {
            'String': 'String'
          });
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScriptRunResult</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScriptRunResult</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['logs'] && !(typeof data['logs'] === 'string' || data['logs'] instanceof String)) {
        throw new Error("Expected the field `logs` to be a primitive type in the JSON string but got " + data['logs']);
      }
      return true;
    }
  }]);
  return ScriptRunResult;
}();
/**
 * @member {String} logs
 */
ScriptRunResult.prototype['logs'] = undefined;

/**
 * @member {Object.<String, String>} files
 */
ScriptRunResult.prototype['files'] = undefined;
var _default = ScriptRunResult;
exports.default = _default;